import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'

import Tag from 'discada/dist/Tag'

import {
  getFilterGroup,
  getFilterGroups,
  isFilterValueSelected,
} from 'selectors/inventorySelectors'

import { removeFromPageState } from 'actions/pageStateActions'
import { toggleFilter, clearFilters } from 'actions/inventoryActions'

import './InventoryFilters.scss'

const FILTER_GROUP_ORDER = [
  'condition',
  'year',
  'make',
  'model',
  'trim',
  'body',
  'fuel-type',
  'passengers',
  'lot',
  'model-number',
]

///////////////////////////////////////////////////////////////////////////

export function FilterPreso(props) {
  let {
    value,
    count,
    selected,
    className,
    toggleFilter,
    onClick = () => {},
  } = props

  return (
    <Tag
      compound
      className={c('inventory-filter', className, {
        selected,
      })}
      onClick={() => {
        toggleFilter(props)
        onClick(props)
      }}
    >
      <Tag color="primary">
        {value} <span className="filter-result-count">({count || 0})</span>
      </Tag>
      {selected && <Tag color="primary" isDelete />}
    </Tag>
  )
}

export const Filter = connect(
  (state, op) => {
    return {
      ...op,
      selected: isFilterValueSelected(state, op.filter, op.value),
    }
  },
  { toggleFilter },
)(FilterPreso)

///////////////////////////////////////////////////////////////////////////

export class FilterGroupPreso extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      expanded: true,
    }

    this.toggle = () => this.setState({ expanded: !this.state.expanded })
  }

  render() {
    let { label, filters = [], className } = this.props,
      { expanded } = this.state

    return (
      <div
        className={c('filter-group', `filter-group-${label}`, className, {
          expanded,
        })}
      >
        <h4>{label}</h4>
        {expanded && (
          <div className="filters-list">
            {sortBy(filters, f => f.value).map((f, i) => (
              <Filter key={i} {...f} />
            ))}
          </div>
        )}
      </div>
    )
  }
}

export const FilterGroup = connect((state, op) => ({
  expanded: get(op.filters, 'length', 0) < 50,
  ...op,
}))(FilterGroupPreso)

///////////////////////////////////////////////////////////////////////////

export function InventoryFiltersPreso({
  filterGroups,
  className,
  closeFiltersModal,
}) {
  if (isEmpty(filterGroups)) return null

  return (
    <div className={c('inventory-filters', className)}>
      {FILTER_GROUP_ORDER.filter(k => !isEmpty(filterGroups[k])).map(k => (
        <FilterGroup
          key={k}
          closeFiltersModal={closeFiltersModal}
          label={k}
          filters={filterGroups[k]}
        />
      ))}
    </div>
  )
}

export const InventoryFilters = connect(
  (state, op) => ({
    ...op,
    filterGroups: op.group
      ? { [op.group]: getFilterGroup(state, op.group) }
      : getFilterGroups(state),
  }),
  { removeFromPageState, clearFilters },
)(InventoryFiltersPreso)
